import React, { useState } from "react";
import { useToast } from "../../../hooks/use-toast";
import { ActivityNotAllowedICDAxiosInstance } from "../../../Network/activityNotAllowedICDAxiosInstance";

interface FileUploadProps {
  fetchItems?: () => Promise<void>;
}

const FileUpload: React.FC<FileUploadProps> = ({ fetchItems }) => {
  const [isUploading, setIsUploading] = useState(false);
  const { toast } = useToast();

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event.target.files?.[0];

    if (!file || isUploading) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      setIsUploading(true);

      // Swagger:
      // POST /ActivityNotAllowedWithIcd/uploadFileActivityNotAllowedWithIcd
      const response = await ActivityNotAllowedICDAxiosInstance.post(
        "uploadFileActivityNotAllowedWithIcd",
        formData,
      );

      if (response.data?.success === false) {
        throw new Error(
          response.data?.error ||
            response.data?.message ||
            "Failed to upload file.",
        );
      }

      if (fetchItems) {
        await fetchItems();
      }

      toast({
        title: "Success",
        description:
          response.data?.message ||
          "Activity Not Allowed with ICD file uploaded successfully.",
      });
    } catch (error: any) {
      toast({
        title: "Upload Error",
        description:
          error.response?.data?.error ||
          error.response?.data?.message ||
          error.message ||
          "Failed to upload file.",
        variant: "destructive",
      });
    } finally {
      setIsUploading(false);
      event.target.value = "";
    }
  };

  return (
    <label
      style={{
        width: 42,
        height: 42,
        borderRadius: "50%",
        background: isUploading ? "#94a3b8" : "#2563eb",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: isUploading ? "not-allowed" : "pointer",
        boxShadow: "0 3px 8px rgba(37,99,235,0.25)",
      }}
      title="Upload Activity Not Allowed with ICD file"
      data-testid="activity-not-allowed-icd-upload"
    >
      <i
        className={
          isUploading
            ? "fa-solid fa-spinner fa-spin"
            : "fa-solid fa-upload"
        }
      />
      <input
        type="file"
        accept=".xlsx,.xls,.csv"
        onChange={handleFileChange}
        disabled={isUploading}
        style={{ display: "none" }}
        data-testid="activity-not-allowed-icd-upload-input"
      />
    </label>
  );
};

export default FileUpload;
